<template>
  <div class="main">
    <van-nav-bar>
      <template #title>
        <span style="font-size: 1rem; color: #fff;">{{ $t('goods.title') }}</span>
      </template>
    </van-nav-bar>
    <div id="content">
      <div class="gif" v-if="bannerUrl">
        <img :src="bannerUrl" />
      </div>

      <!-- 地区筛选标签已隐藏 -->
      <div class="select_wrap" v-if="false">
        <div :class="{active: addressActive === 0}" @click="addressActive = 0">{{ $t('goods.every') }}</div>
        <div :class="{active: addressActive === index + 1}" v-for="(item, index) in addressList" :key="index" @click="addressActive = index + 1">{{ item.name }}</div>
      </div>

      <div class="view">
        <div class="left">
          <div class="card" v-for="item in xuanfeiLeftList" :key="item.id" @click="goDetail(item)">
            <div class="img_wrap">
              <img :src="item.img_url[0]">
              <div class="tip">
                <span>{{ $t('index.tip2') }}</span>
              </div>
              <div class="shadow">
                <div>
                  <van-icon name="location" color="#fff" size="13"></van-icon>
                  <span>{{ item.diqu }}</span>
                </div>
                <div class="btn">{{ $t('goods.subscribe') }}</div>
              </div>
            </div>
            <div class="row">{{ item.type[0].name }}</div>
            <div class="row">
              <div><i class="circle"></i>{{ item.xuanfei_name }}</div>
              <div>
                <van-icon name="like" color="#DC63A1"/>
                <span>{{ item.zan }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="card" v-for="item in xuanfeiRightList" :key="item.id" @click="goDetail(item)">
            <div class="img_wrap">
              <img :src="item.img_url[0]">
              <div class="tip">
                <span>{{ $t('index.tip2') }}</span>
              </div>
              <div class="shadow">
                <div>
                  <van-icon name="location" color="#fff" size="13"></van-icon>
                  <span>{{ item.diqu }}</span>
                </div>
                <div class="btn">{{ $t('goods.subscribe') }}</div>
              </div>
            </div>
            <div class="row">{{ item.type[0].name }}</div>
            <div class="row">
              <div><i class="circle"></i>{{ item.xuanfei_name }}</div>
              <div>
                <van-icon name="like" color="#DC63A1"/>
                <span>{{ item.zan }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerUrl: '',
      addressList: [],
      addressActive: 0,
      age: null,
      search: {
        class_id: 0,
        page: 1,
        limit: 999,
        name: '',
        type: 1
      },
      allXuanfeiList: [],
      ageList: []
    };
  },
  watch: {
    addressActive(newVal) {
      if(newVal === 0) {
        this.search.class_id = 0
      }else {
        this.search.class_id = this.addressList[newVal - 1].id
      }
      console.log(this.search.class_id)
      this.getXuanfeiList()
    }
  },
  created() {
    this.getBanner();
    this.getAddress();
    this.getXuanfeiList();
  },
  computed: {
    xuanfeiList() {
      return this.allXuanfeiList.filter(item => {
        if (this.age) {
          return item.age === this.age
        } else {
          return true
        }
      })
    },
    xuanfeiLeftList() {
      return this.xuanfeiList.filter((item, index) => {
        return index % 2 == 0
      })
    },
    xuanfeiRightList() {
      return this.xuanfeiList.filter((item, index) => {
        return index % 2 !== 0
      })
    }
  },
  methods: {
    showTag() {
      this.$toast(this.$t('goods.tag'));
    },
    getBanner() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        const banners = res.data?.banners || [];
        this.bannerUrl = banners[0]?.url || '';
      })
    },
    getAddress() {
      this.$http({
        method: 'post',
        url: 'xuanfei_address'
      }).then(res => {
        if (res.code === 200) {
          this.addressList = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getXuanfeiList() {
      this.$http({
        method: 'get',
        url: 'xuanfei_list',
        data: this.search
      }).then(res => {
        if (res.code === 200) {
          console.log(res)
          this.allXuanfeiList = res.data.data.map(item => {
            item.zan = parseInt(Math.random() * 30000 + 20000)
            return item
          })
          this.ageList = Array.from(new Set([...res.data.data.map(item => item.age)])).sort((a, b) => a - b)
          this.age = null
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

    goDetail(e) {
      localStorage.setItem('xuanfeiDetail', JSON.stringify(e))
      this.$router.push(`XuanfeiDetail`);
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 0;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
  min-height: 100%;
  .gif {
    width: 92%;
    margin: 0.7rem auto 0.2rem;
    border-radius: 1.15rem;
    overflow: hidden;
    aspect-ratio: 750 / 340;
    img{
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .select_wrap{
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    padding: 0.55rem 4% 0.2rem;
    div{
      font-size: .76rem;
      padding: 0.28rem 0.7rem;
      text-align: center;
      width: auto;
      color: #6f6283;
      background: #fff;
      border-radius: 2rem;
      box-shadow: 0 0.15rem 0.45rem rgba(183, 156, 236, 0.12);
      cursor: pointer;
      margin-bottom: 0;
    }
    .active{
      color: #fff;
      background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 100%);
      transform: none;
      border-bottom: none;
    }
  }
  
  #content{
    padding-bottom: 3.2rem;
  }


  .view {
    width: 96%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    margin-top: 4%;

    >div {
      padding-top: 0;
      width: 48%;
      margin: 0 auto;
      border-top: none;
    }

    .card {
      border-radius: 1.1rem;
      position: relative;
      margin-bottom: 0.75rem;
      background: #fff;
      overflow: hidden;
      box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.16);
      padding-bottom: 0.45rem;
      .img_wrap{
        border-radius: 0;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 0.625rem;
        }
        .tip {
          position: absolute;
          z-index: 1;
          top: auto;
          right: auto;
          left: 0.4rem;
          bottom: 2.35rem;
          width: auto;
          height: auto;
          background: linear-gradient(120deg, #ffcfb4 0%, #ffb3a7 100%);
          transform: none;
          opacity: 1;
          border-radius: 1rem;
          padding: 0.08rem 0.4rem;

          span {
            position: static;
            bottom: auto;
            left: auto;
            font-size: 0.68rem;
            font-weight: 600;
            color: #fff;
          }
        }
        .shadow{
          height: 1.9rem;
          width: 100%;
          position: absolute;
          bottom: 0;
          background: linear-gradient(180deg, rgba(74, 40, 80, 0) 0%, rgba(74, 40, 80, 0.55) 100%);
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding: 0.3rem 0.45rem;
          font-size: 0.75rem;
          color: #fff;
          .btn{
            border: none;
            padding: 0.08rem 0.4rem;
            border-radius: 1rem;
            background: linear-gradient(120deg, #f7a1c0, #c3a3f2);
            opacity: 1;
            font-size: 0.68rem;
          }
        }
      }
      .row{
        font-size: 0.82rem;
        color: #6f6283;
        padding: 0.35rem 0.5rem 0;
        display: flex;
        justify-content: space-between;
        .circle{
          display: inline-block;
          margin-right: .2rem;
          width: .8rem;
          height: .8rem;
          border-radius: 50%;
          background: #efba8f;
        }
      }

      .tag {
        background-color: #ff2a77;
        width: 3rem !important;
        height: 2rem !important;
        border-top-left-radius: 0.56rem !important;
        font-size: 1.09375rem !important;
        color: #fff;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 0.9375rem;
        border-bottom-right-radius: 0.9375rem;
        top: 0;
      }

      .info {
        position: absolute;
        bottom: 5%;
        width: 100%;

        .text {
          font-size: 1.3rem;
          text-align: center;
          color: #fff;
          font-weight: 600;
        }

        .bottom {
          color: #fff;
          background-color: #ff1a6d;
          width: 60%;
          font-size: .9rem;
          margin: 0 auto;
          margin-top: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 3%;
          padding-bottom: 3%;
          border-radius: 0.9375rem;
        }
      }
    }
  }
}


</style>
